import { useState } from 'react';
import { useCappsRenterDocumentsWebApiHandler_listActiveDocuments } from '@zg-rentals/ts-capps-client-react-query';
import { toDocument } from './useRetrieveActiveDocuments';

/** Every active file of the renter, read once per step visit. No cache tag, so uploads and deletes do not read the whole library again */
export function useSavedDocuments() {
  const { data, isFetchedAfterMount } = useCappsRenterDocumentsWebApiHandler_listActiveDocuments({
    refetchOnMount: 'always',
    meta: { context: { api: 'cappsRenterDocuments', details: 'listActiveDocuments' } },
  });
  const isCurrent = isFetchedAfterMount && !!data;
  // capps sends the expired flag only on its first call, so a later refetch must not clear it
  const [areDocumentsExpired, setAreDocumentsExpired] = useState(false);
  if (!areDocumentsExpired && isCurrent && data.areDocumentsExpired) {
    setAreDocumentsExpired(true);
  }
  return {
    documents: isCurrent ? data.documentInfoList.map(toDocument) : [],
    areDocumentsExpired,
  };
}
